import {Avatar, Card, Label} from 'platform/components';
import {Grid, Heading, HStack, VStack} from 'platform/foundation';

import {GetArticleResponse} from '@dms/api/warehouse';
import i18n from '@dms/i18n';

interface CurrentStockForecastCardsProps {
  stockManagement: GetArticleResponse['stockManagement'];
  handlingUnitLabel: string;
}

export function CurrentStockForecastCards(props: CurrentStockForecastCardsProps) {
  return (
    <Grid columns={2} spacing={4}>
      <Card colorStripe="neutral">
        <HStack spacing={4} align="center" width="100%">
          <Avatar icon="custom/warehouse" variant="square" />
          <VStack>
            <Label>{i18n.t('entity.warehouse.labels.currentStock')}</Label>
            <Heading
              size={1}
            >{`${props.stockManagement.currentStockQuantity ?? 0} ${props.handlingUnitLabel}`}</Heading>
          </VStack>
        </HStack>
      </Card>
      <Card colorStripe="green">
        <HStack spacing={4} align="center" width="100%">
          <Avatar
            icon="action/trending_up"
            variant="square"
            iconColor="palettes.green.80.100"
            color="palettes.green.20.100"
          />
          <VStack>
            <Label tooltip={i18n.t('entity.warehouse.labels.forecastTooltip')}>
              {i18n.t('entity.warehouse.labels.forecast')}
            </Label>
            <Heading
              size={1}
            >{`${props.stockManagement.forecastQuantity ?? 0} ${props.handlingUnitLabel}`}</Heading>
          </VStack>
        </HStack>
      </Card>
    </Grid>
  );
}
